export const viewSyncCardNumber = 6;
